module.exports = __webpack_public_path__ + "img/b_Forsmax_left.dfb49849.jpeg";